import { Action, createReducer, on } from '@ngrx/store';
import { CoursesState, initialState } from './course.state';

import * as CourseActions from './course.actions';

const coursesReducer = createReducer(
  initialState,
  on(CourseActions.fetchCourseItemsSuccess, (state, { courseResponse }) => {
    const { docs, ...pagination } = courseResponse;

    return {
      ...state,
      courseItems: docs,
      pagination,
    };
  }),
  on(CourseActions.initiateCourseCreation, (state) => {
    return {
      ...state,
      createdCourseItem: null,
    };
  }),
  on(CourseActions.initiateCourseCreationSuccess, (state, { categories }) => {
    return {
      ...state,
      categories,
    };
  }),
  on(CourseActions.clearCreatedCourseItem, (state) => {
    return {
      ...state,
      createdCourseItem: null,
    };
  }),
  on(CourseActions.selectCourseItemSuccess, (state, { item }) => {
    return {
      ...state,
      selectedCourseItem: item,
    };
  }),
  on(CourseActions.createCourseItemSuccess, (state, { courseItem }) => {
    return {
      ...state,
      createdCourseItem: courseItem,
    };
  }),
  on(CourseActions.updateCourseItemSuccess, (state, { courseItem }) => {
    return {
      ...state,
      createdCourseItem: courseItem,
    };
  }),
  on(CourseActions.restoreCreateCourseItemSuccess, (state, { courseItem }) => {
    return {
      ...state,
      createdCourseItem: courseItem,
    };
  }),
  on(CourseActions.syncCourseContents, (state) => {
    return {
      ...state,
      isSyncingContents: true,
    };
  }),
  on(CourseActions.syncCourseContentsSuccess, (state, { courseItem }) => {
    return {
      ...state,
      createdCourseItem: courseItem,
      isSyncingContents: false,
      isSyncSuccess: true,
    };
  }),
  on(CourseActions.fetchEnrollmentsSuccess, (state, { enrolledCourses }) => {
    return {
      ...state,
      enrolledCourses,
    };
  }),
  on(CourseActions.resetCourseState, () => {
    return initialState;
  }),
  on(CourseActions.requestForReviewSuccess, (state, { courseItem }) => {
    return {
      ...state,
      createdCourseItem: courseItem,
    };
  }),
  on(CourseActions.publishCourseSuccess, (state, { courseItem }) => {
    return {
      ...state,
      createdCourseItem: courseItem,
    };
  })
);

export function reducer(state: CoursesState | undefined, action: Action) {
  return coursesReducer(state, action);
}
